import React, { useContext } from 'react';
import { createURL, getClientEnvironmentDetails } from '@sm/utils';
import { Immutable } from '@wds/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute } from '@sm/metrics';
import { NavButton } from './NavButton';
import HeaderContext from '../../HeaderContext';

export type MainNavButtonProps = Immutable<{
  children?: React.ReactNode;
  href?: string;
  label: string;
  active?: boolean;
  navItem: string;
}>;

const MainNavButton = ({
  children,
  href,
  label,
  active,
  navItem,
}: MainNavButtonProps) => {
  const url = href && createURL(href, { ut_source: 'header' });
  const { isNode } = getClientEnvironmentDetails();
  const currentPath = !isNode ? document.location.pathname : '';
  const pattern = new RegExp(`^${currentPath}/?$`);
  const match = href ? pattern.test(href) : false;
  const isActive = active || match;

  const { pageURL, pageName } = useContext(HeaderContext);
  const metricsData = generateMetricsAttribute({
    data: {
      url: pageURL,
      pageName,
      amplitudeEvent: 'header clicked navigation',
      navItem,
    },
  });
  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton
                href={url}
                label={label}
                active={isActive}
                data-sm-metrics={metricsData}
              >
                {children || label}
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url} data-sm-metrics={metricsData}>
              {children || label}
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default MainNavButton;
export { MainNavButton };
